import Image from 'next/image';
import styles from './mini-card.module.scss';
type Props = {
  image: string | undefined;
  title: string;
  onClick: () => void;
  isSelected: boolean;
};
import DefaultProductPlaceholder from '@/assets/images/Yellow.png';

const MiniProductCard = ({ image, title, onClick, isSelected }: Props) => {
  return (
    <div
      className={`${styles.miniCardWrapper} ${isSelected ? styles.selected : ''}`}
      onClick={onClick}
    >
      <Image
        src={image ? image : DefaultProductPlaceholder}
        alt="mini-product"
        width={56}
        height={56}
        className={styles.image}
      />
      <h4>{title}</h4>
    </div>
  );
};

export default MiniProductCard;
